module.exports = __webpack_public_path__ + "assets/feizhengshiwendengji.89365e18.svg";